export default __webpack_public_path__ + "static/media/photo-blob.3bed2cf6.svg";